import {SmetioPreloader} from
    "./../../smetioPreloader/SmetioPreloader.js";

export function render(){

    let output = "";
    
    const preloader = new SmetioPreloader();
    preloader.extra_attributes = `data-state="spinner_on_top"`;   
      
    this.openOnClick_preloader = preloader.render();
    
    this.openOnClick_divs = this.createOpenOnClickDivs();

    output += `
    
        <div 
            id ="${this.id}" 
            class=" 
                smetio-app-ui-menu 
                smetio-tab-controller 
                smetio-button 
                ${this.extraClass}
            " 
            data-smetio-tab-toggle="#${this.tab_toggle_id}" 
            data-smetio-text="${this.text}"
            data-smetio-text-type="data-text"
            data-smetio-text-token="${this.textToken}"
            data-active="${this.isActive}"
            
        > 

            <div class=" smetio-app-ui-menu-icon">
                
                <i class="smetio-icon smetio-icon-${this.icon}"></i> 
            
            </div>
            
            <div 
                class=" smetio-app-ui-menu-text"
                data-smetio-text-type="html-text"
                data-smetio-text-token="${this.textToken}"
                ${this.text_extra_attributes}
                
            >
                
                 ${this.text}  
            
            </div>	                    
        	                
        </div>  
              
    `;

    return output;

};
